// extracted by mini-css-extract-plugin
module.exports = {"title":"_02712f2b3b--title--LDQrP","labels":"_02712f2b3b--labels--ek1ZQ"};